import { useIsSuspended } from "./suspension";

export default {useIsSuspended}